<span class="pl-3 text-white sen-fs10 font-weight-bold">{{global.sProjectName}} {{version}}
    {{global.sCopyright}}
</span>